import { cn } from "@/shared/lib/utils";
import { Skeleton } from "../skeleton";

export function CalendarSkeleton({ className }: { className?: string }) {
	return (
		<div className={cn("space-y-3", className)}>
			<div className="flex items-center justify-between">
				<Skeleton className="h-6 w-32 rounded-md" />
				<div className="flex gap-2">
					<Skeleton className="size-8 rounded-md" />
					<Skeleton className="size-8 rounded-md" />
				</div>
			</div>
			<div className="grid grid-cols-7 gap-1">
				{Array.from({ length: 7 }, (_, i) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list, fixed order
					<Skeleton className="mx-auto h-4 w-8 rounded-md" key={i} />
				))}
			</div>
			{Array.from({ length: 5 }, (_, row) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list, fixed order
				<div className="grid grid-cols-7 gap-1" key={row}>
					{Array.from({ length: 7 }, (_, col) => (
						// biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list, fixed order
						<Skeleton className="h-10 w-full rounded-md" key={col} />
					))}
				</div>
			))}
		</div>
	);
}
